import { TreatmentTypeListCard } from 'app/core/models';
import { TreatmentType } from 'app/core/enums';

export const AppTreatmentTypes: TreatmentTypeListCard[] = [
  {
    priceBase: 5,
    price: 99.0,
    currency: 'USD',
    tags: [],
    printPrice: 0.0,
    backupPrice: 100.0,
    printHoursToSLA: 0.0,
    scribingPrice: 0.0,
    defaultRushPrice: 0.0,
    rushAdditionalPrice: 0.0,
    hoursToSLA: 48.0,
    revisionType: 0,
    isAi: false,
    id: TreatmentType.Moment,
    name: 'Moment',
    minHoursToSLA: 0,
    isFromNGCOM: false,
    imagePath: '',
  },
];
